// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:ctjwDq */\n.qQT3B{align-items:center;display:inline-flex;gap:var(--audio-spacing-8);max-width:100%;overflow-x:auto;overscroll-behavior:contain}.Kq0YZ{margin-top:var(--audio-spacing-24)}.Kq0YZ[data-state=\"inactive\"]{display:none}.XZjfd{padding-top:var(--audio-spacing-16)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "qQT3B",
	"content": "Kq0YZ",
	"commentsLayout": "XZjfd"
};
export default ___CSS_LOADER_EXPORT___;
